import CONSTANT from "../../constants/Constant";
import Info from "../../assets/img/utils/info.svg";
import React from "react";
import { useSelector } from "react-redux";
import useEditAssessmentHeaderAndFooter from "./hooks/useEditAssessmentHeaderAndFooter";
import './EditAssessmentQuestionTab.scss';

const EditAssessmentQuestionTab = () => {
    const { handleOnClickGroupTab, handleSetShowInstruction } = useEditAssessmentHeaderAndFooter();
    const editAssessmentGroup = useSelector(state => state.editAssessment);
    const groups = editAssessmentGroup?.groups || [];

    const baseData = editAssessmentGroup?.baseData || {};
    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
    const currentGroup = groups.filter(group => group.groupId === currentGroupId)[0] || {};

    return (
        <div className="edit-assessment-question-tab__nav">
            <div className="edit-assessment-question-tab__nav-items">
                {groups.length > 0 && (
                    groups.map((group) => {
                        return (
                            <div 
                                className={`edit-assessment-question-tab__nav-item cursor-pointer flex-basis-20 edit-assessment-question-tab__nav-item--clip-path`}
                                data-state={group.groupId === currentGroupId ? 'current' : ''}
                                key={group?.groupId}
                            >
                                <div className="edit-assessment-question-tab__nav-body"
                                     onClick={() => handleOnClickGroupTab(group?.groupId)}
                                >
                                    <div className="edit-assessment-question-tab__nav-number">
                                        {group?.shortName}
                                    </div>
                                    <div className="edit-assessment-question-tab__nav-label">
                                        <div className="edit-assessment-question-tab__nav-label-title heading-primary">
                                            {group?.groupName}
                                        </div>
                                    </div>
                                    <div>
                                        {(currentGroup?.groupTitle && (group?.groupId === currentGroupId)) &&
                                            <div
                                                onClick={(e) => {
                                                    e.stopPropagation(); // Prevent triggering the tab click event
                                                    handleSetShowInstruction(true);
                                                }}
                                                className="info-icon-wrapper ml-10">
                                                <img src={Info} alt="Information"/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    )
}

export default EditAssessmentQuestionTab;